import {
    APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS,
    PROVIDER_EXPERIENCE_IS_LOADING,
} from "../actions/actionTypes";
import { DATE, LOB_OPTIONS, REGION_OPTIONS } from "@src/apps/ProviderExperience/constant";

interface ProviderExperienceState {
    filterPayload: object;
    isLoading: boolean;
    error: string | null;
}

const initialState: ProviderExperienceState = {
    filterPayload: {
        lineOfBusiness: LOB_OPTIONS[0].value,
        timePeriod: [DATE, DATE],
        region: REGION_OPTIONS[0].value,
    },
    isLoading: false,
    error: null
};

const ProviderExperienceReducer = (state = initialState, action: { type: string; payload?: any }): ProviderExperienceState => {
    switch (action.type) {
        case APPLY_PROVIDER_EXPERIENCE_FILTER_SUCCESS:
            if (typeof action.payload === 'object' && action.payload !== null) {
                return {
                    ...state,
                    filterPayload: { ...state.filterPayload, ...action.payload }
                };
            }
            return {
                ...state,
                filterPayload: { ...state.filterPayload, lineOfBusiness: action.payload }
            };
        case PROVIDER_EXPERIENCE_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        default:
            return state;
    }
};

export default ProviderExperienceReducer;